module.exports = __webpack_public_path__ + "img/image-hero-3-banner.df6c2aaf.png";